import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import Hero from "./Hero";

export default function Signature() {
const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
const [categories, setCategories] = useState([]);
const [categoryLoading, setCategoryLoading] = useState(true);

const API_URL = "https://aethearia.store/superadmin/api/categories";
const IMAGE_BASE_URL = "https://aethearia.store/superadmin/uploads/category/";

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth < 768);
  window.addEventListener("resize", handleResize);

  return () => window.removeEventListener("resize", handleResize);
}, []);

useEffect(() => {
  fetch(API_URL)
    .then((res) => res.json())
    .then((result) => {
      if (result.status && result.data) {
        setCategories(result.data);
      }
      setCategoryLoading(false);
    })
    .catch((error) => {
      console.error("Category API Error:", error);
      setCategoryLoading(false);
    });
}, []);

  return (
    <div
      style={{
        color: "#4b3b2a",
      }}
    >
      {/* NAVBAR */}
      <Header/>
{!isMobile && (
<div
  style={{
    marginTop: "140px",
    position: "relative",
    width: "100%",
    objectFit: "contain",
    padding:"0 150px",
  }}
>
  <img
    src="/banner/candle banner .jpg.jpeg"
    alt="Flame"
    style={{
      width: "100%",
      height: "400px",
      objectFit: "cover",
    }}
  />
    <div
    style={{
      position: "absolute",
      top: "50%",
      left: "12%",
      transform: "translateY(-50%)",
      maxWidth: "500px",
     
    }}
  >
    <h1
      style={{
        fontSize: "30px",
        marginBottom: "20px",
        fontWeight: "100",
         color: "rgb(76, 20, 78)",
         textTransform:"none !important"
      }}
    >
      You Take Vitamins For Your Body. What Are You Feeding Your Soul?
      
    </h1>

    <p
      style={{
        fontSize: "14px",
        lineHeight: "1.8",
        marginBottom: "25px",
        color: "rgb(77,67,56,1)",
        textTransform:"none "
      }}
    >
You moisturize your skin. You track your steps. You count your macros. But when was the last time you did something just to feel okay — not productive, not impressive, just okay?    </p>
  
    <p
      style={{
        fontSize: "14px",
        lineHeight: "1.8",
        marginBottom: "25px",
        color: "rgb(77,67,56,1)",
        textTransform:"none"
      }}
    >We built Aethearia because we believe your space is part of your health.</p>
  </div>
</div>
)}

{isMobile && (
  <div
    style={{
      marginTop: "80px",
      padding: "20px 20px 0 20px",
      display: "flex",
      justifyContent: "center",
    }}
  >
    {/* CARD CONTAINER */}
    <div
      style={{
        width: "100%",
        borderRadius: "16px",
        padding: " 0 20px",
        
      }}
    >
      {/* <h2
        style={{
          fontSize: "15px",
          lineHeight: "1.3",
          marginBottom: "15px",
          color: "#4c144e",
          fontWeight: "500",
           textAlign:"center"
        }}
      >
        not any other candle brands
      </h2> */}
      <h2
        style={{
          fontSize: isMobile ? "20px" : "25px",
          lineHeight: "1.3",
          marginBottom: "15px",
          color:"#4c144e",
          fontWeight: "100",
           textAlign:"center",
           textTransform:"none"
        }}
      >
        You Take Vitamins for your Body. {isMobile && <br />}What are you Feeding your Soul?
      </h2>

      {/* IMAGE */}
      <img
        src="/images/Wellness series.png"
        alt="Wellness"
        style={{
          width: "100%",
          // height: "70%",
          objectFit: "cover",
          borderRadius: "5px",
          marginBottom: "15px",
        }}
      />

      <p
        style={{
          fontSize: "14px",
          lineHeight: "1.7",
          marginBottom: "5px",
          color: "#444",
          textAlign:"justify",
          textTransform:"none"
        }}
      >
       You Moisturize Your Skin. You Track Your Steps. You Count Your Macros. But When Was The Last Time You Did Something Just To Feel Okay — Not Productive, Not Impressive, Just Okay?
      </p>

       <p
        style={{
          fontSize: "14px",
          lineHeight: "1.7",
          color: "#444",
          textAlign:"justify",
          textTransform:"none",
          marginBottom: "20px",
        }}
      >
We Built Aethearia Because We Believe Your Space Is Part Of Your Health.      </p>
    </div>
  </div>
)}
      {/* HERO */}


      {/* SECOND SECTION */}
<section
  style={{
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "34% 36% 24%",
    gap: isMobile ? "20px 0 0 0" : "0",
     padding: isMobile ? "0 20px" : "0 150px",
      // borderRadius: "5px",
      marginTop:isMobile ? "0" : "0",

  }}
>
  {/* IMAGE */}
  <div>
    <img
      src="/banner/candle-banner.jpeg"
      alt=""
      style={{
        width: "100%",
        height: isMobile ? "100%" : "320px",
        objectFit: "cover",
        padding: isMobile ? "0 20px" : "0",
        borderRadius: isMobile ? "15px" : "0"
      }}
    />
  </div>

  {/* CONTENT */}
  <div
    style={{
      padding: isMobile ? "0 20px"  : "15px 60px 0 60px",
      color: "#4d4338",
      textAlign: isMobile ? "center" : "left",
    }}
  >
    <h2
      style={{
        fontSize: isMobile ? "20px" : "30px",
        fontWeight: 100,
        margin: "10px 0",
       color:"#4c144e",
       textTransform:"none"
      }}
    >
      The Candle You Know.
     {!isMobile && <br />}
      And the One You Don't.
    </h2>

    <p
      style={{
        fontSize: "14px",
        lineHeight: 1.8,
        marginBottom: isMobile ? "5px" : "25px",
        textAlign: isMobile ? "justify" : "left",
        textTransform:"none"
      }}
    >
      You've seen candles everywhere — pretty, fragrant, forgotten.
      That's not what we make.
    </p>

    <p
      style={{
        fontSize: "14px",
        lineHeight: 1.8,
         textAlign: isMobile ? "justify" : "left",
         textTransform:"none"
      }}
    >
      Aethearia candles are built around essential oils, not synthetic fragrance
      or lab-made perfumes, but plant-derived compounds used for centuries to
      regulate the nervous system, ease anxiety, restore focus, and signal to
      your body: you're safe, you can soften now.
    </p>
  </div>

  {/* QUOTE */}
 <div
  style={{
    padding: isMobile ? "20px" : "0 50px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#664e64",
    textAlign: "center",
    textTransform: "none",
  }}
>
  <blockquote
    style={{
      margin: 0,
      fontSize: isMobile ? "14px" : "30px",
      fontStyle: "italic",
      fontFamily: "serif",
      fontWeight: 100,
      textTransform: "none",
      textAlign: isMobile ? "center" : "left",
      borderLeft: isMobile
        ? "none"
        : "1px solid rgb(102, 78, 100)",
      paddingLeft: isMobile ? "0" : "10px",
    }}
  >
    “This is not
    {!isMobile && <br />} aromatherapy
    {!isMobile && <br />} as a buzzword.
    {!isMobile && <br />}
    This is fragrance
    {!isMobile && <br />} as function.”
  </blockquote>
</div>
</section>

      {/* STORY SECTION */}

{!isMobile && (
   <div
  style={{
    position: "relative",
    width: "100%",
    padding: '0 150px',
  }}
>
  <img
    src="/aethearia-img/11.png"
    alt="Flame"
    style={{
      width: "100%",
      height: "400px",
      objectFit: "cover",
      display: "block",
    }}
  />

  {/* Content Overlay */}
  <div
    style={{
      position: "absolute",
      top: "51%",
      left: "12%",
      transform: "translateY(-50%)",
      maxWidth: "500px",
     
    }}
  >
    <h1
      style={{
        fontSize: "30px",
        marginBottom: "20px",
        fontWeight: "100",
         color: "rgb(76, 20, 78)",
      }}
    >
      we forget something important
      
    </h1>

    <p
      style={{
        fontSize: "14px",
        lineHeight: "1.8",
        marginBottom: "25px",
        color: "rgb(77,67,56,1)",
        textTransform:"none"
      }}
    >
     We are among the most overstimulated generations in history. Long commutes, longer workdays, hours, screens that never go dark, cities that never go quiet. Somewhere along the way, we stopped tending to how we feel inside our own homes.
    </p>
     <p
      style={{
        fontSize: "14px",
        lineHeight: "1.8",
        marginBottom: "25px",
        color: "rgb(77,67,56,1)",
        textTransform:"none"
      }}
    >

Ritual has always helped humans regulate themselves. Incense at dawn. Sacred smoke at dusk. Scent marking prayer, pause, and restoration.
    </p>
    <p
      style={{
        fontSize: "14px",
        lineHeight: "1.8",
        marginBottom: "25px",
        color: "rgb(77,67,56,1)",
        textTransform:"none"
      }}
    >Aethearia is that wisdom, redesigned for the life you live today.</p>
  </div>
</div>
)}

{isMobile && (
  <div
    style={{
      padding: "0 20px",
      display: "flex",
      justifyContent: "center",
    }}
  >
    {/* CARD CONTAINER */}
    <div
      style={{
        borderRadius: "16px",
        padding: " 0 20px",
        
      }}
    >
      <h2
        style={{
          fontSize: isMobile ? "20px" : "25px",
          lineHeight: "1.3",
          marginBottom: "15px",
          color:"#4c144e",
          fontWeight: "100",
           textAlign:"center",
           textTransform:"none"
        }}
      >
        We Forget Something Important.
      </h2>

      {/* IMAGE */}
      <img
        src="/images/Sculptures.png"
        alt="Wellness"
        style={{
          width: "100%",
          objectFit: "cover",
          borderRadius: "5px",
          marginBottom: "15px",
          textTransform:"none"
        }}
      />

      <p
        style={{
          fontSize: "14px",
          lineHeight: "1.7",
          color: "#444",
          textAlign:"justify",
          textTransform:"none"
        }}
      >
We Are Among The Most Overstimulated Generations In History. Long Commutes, Longer Workdays, Hours, Screens That Never Go Dark, Cities That Never Go Quiet. Somewhere Along The Way, We Stopped Tending To How We Feel Inside Our Own Homes.      </p>
   <p  style={{
          fontSize: "14px",
          lineHeight: "1.7",
          color: "#444",
          textAlign:"justify",
          marginTop:"10px",
          textTransform:"none"
        }}>
    Ritual Has Always Helped Humans Regulate Themselves. Incense At Dawn. Sacred Smoke At Dusk. Scent Marking Prayer, Pause, And Restoration.
   </p>
   <p  style={{
          fontSize: "14px",
          lineHeight: "1.7",
          color: "#444",
          textAlign:"justify",
          marginTop:"10px",
          textTransform:"none"
        }}>
    Aethearia Is That Wisdom, Redesigned For The Life You Live Today.
   </p>
    </div>
  </div>
)}
      {/* WHY */}
    <section
  style={{
    textAlign: "center",
    padding: isMobile ? "30px 40px" : "20px 60px 30px",
    color: "#4d4338",
  }}
>
  <h2
    style={{
      fontSize: isMobile ? "20px" : "30px",
      marginBottom: "5px",
      color:"#4c144e",
      fontWeight:  100,
      textTransform:"none"
    }}
  >
    So Why Aethearia?
  </h2>

  <p
    style={{
      maxWidth: "680px",
      margin: isMobile ? "0 auto" : "0 auto 60px",
      fontSize: "14px",
      lineHeight: 1.8,
       color: "rgb(77,67,56,1)",
       textAlign: isMobile ? "justify" : "center",
       textTransform:"none"
    }}
  >
    Because we are not selling you a candle. We are offering you a
    practice. Every Aethearia creation is handcrafted with intention —
    from the essential oil blend chosen for its emotional effect, to the
    form sculpted for beauty, to the burn time engineered for your real
    rituals: morning calm, midday focus, evening wind-down, bedtime
    surrender.
  </p>

<div
  style={{
    display: "grid",
    gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
    maxWidth: "1200px",
    margin: "0 auto",
  }}
>
  {[
    {
      title: "Rooter n wellness science",
      desc: "Plant-derived compounds chosen for emotional effect and nervous system support.",
      iconImg: "/aethearia-img/1.png",
    },
    {
      title: "Handcrafted with intention",
      desc: "Poured, finished, and inspected by hand for a level of care machines can't replicate.",
      iconImg: "/aethearia-img/2.png",
    },
    {
      title: "designed to elevate space",
      desc: "Thoughtful design that elevates your space and deepens your ritual.",
      iconImg: "/aethearia-img/3.png",
    },
  ].map((item, index) => (
    <div
      key={item.title}
      style={{
        padding: isMobile ? "10px 20px" : "0 35px",
        borderRight: isMobile
          ? "none"
          : index !== 2
          ? "2px solid #d8d1c8"
          : "none",
        borderBottom:
          isMobile && index !== 2 ? "1px solid #d8d1c8" : "none",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
          alignItems: isMobile ? "center" : "flex-start",
          gap: isMobile ? "14px" : "18px",
          textAlign: isMobile ? "center" : "left",
        }}
      >
        {/* ICON */}
        <div
          style={{
            width: isMobile ? "85px" : "100px",
            height: isMobile ? "85px" : "100px",
            minWidth: isMobile ? "85px" : "100px",
            backgroundColor: "#4c144e",
            WebkitMask: `url(${item.iconImg}) center / contain no-repeat`,
            mask: `url(${item.iconImg}) center / contain no-repeat`,
            marginTop: isMobile ? "0" : "4px",
          }}
        ></div>

        {/* TEXT */}
        <div>
          <h3
            style={{
              fontSize: "14px",
              fontWeight: 100,
              marginBottom: "10px",
              color: "#4c144e",
              textTransform: "uppercase",
              textAlign: isMobile ? "center" : "center",
              textTransform:"none"
            }}
          >
            {item.title}
          </h3>

          <p
            style={{
              fontSize: "14px",
              lineHeight: 1.7,
              margin: 0,
              color: "rgb(77,67,56,1)",
               textAlign: isMobile ? "center" : "center",
               textTransform:"none"
            }}
          >
            {item.desc}
          </p>
        </div>
      </div>
    </div>
  ))}
</div>
</section>



{isMobile ? (
  <section
    style={{
      position: "relative",
      width: "100%",
    }}
  >
    <img
      src="/banner/candle banner  (3).jpg.jpeg"
      alt="What We Make"
      style={{
        width: "90%",
        height: "auto",
        objectFit: "cover",
        display: "block",
        margin: "0 auto",
      }}
    />
  </section>
) : (
  <section
    style={{
      position: "relative",
      width: "100%",
    }}
  >
    <img
      src="/banner/candle banner  (10).png"
      alt="What We Make"
      style={{
        width: "82%",
        objectFit: "contain",
        display: "block",
        margin:"0 auto",
      }}
    />
  </section>
)}

      {/* PROMISE */}
<section
  style={{
    padding: isMobile ? "20px" : "20px 60px",
    textAlign: "center",
    color: "rgb(77,67,56,1)",
  }}
>
  <h2
    style={{
      fontSize: isMobile ? "20px" : "30px",
      fontWeight: 100,
      fontFamily: "serif",
      color: "#4c144e",
    }}
  >
    The Aethearia Promise
  </h2>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: isMobile ? "1fr" : "repeat(3, 1fr)",
      gap: "25px",
      margin: "0 auto",
      maxWidth: '1200px'
    }}
  >
    {[
      {
        iconImg: "/aethearia-img/4.png",
        title: "No Synthetic Fragrance Oils",
        desc: "We will never use synthetic fragrance oils masquerading as wellness.",
      },
      {
        iconImg: "/aethearia-img/5.png",
        title: "No Mass Production",
        desc: "We will never mass-produce what is meant to be personal.",
      },
      {
        iconImg: "/aethearia-img/6.png",
        title: "Purpose Over Trends",
        desc: "We will never make something just because it sells.",
      },
    ].map((item, index) => (
      <div
  key={index}
  style={{
    padding: isMobile ? "12px 14px" : "22px 24px",
    display: "flex",
    alignItems: "center",
    gap: isMobile ? "10px" : "18px",
    minHeight: "120px",
    borderRadius: "5px",
    textAlign: "left",
  }}
>
  {/* LOGO LEFT */}
  <img
    src={item.iconImg}
    alt=""
    style={{
      width: "100px",
      height: "100px",
      objectFit: "contain",
      flexShrink: 0,
      filter:
        "brightness(0) saturate(100%) invert(13%) sepia(49%) saturate(1875%) hue-rotate(266deg) brightness(86%) contrast(98%)",
    }}
  />

  {/* TEXT RIGHT CENTER */}
  <div
    style={{
      display: "flex",
      alignItems: "center",
      minHeight: "100px",
    }}
  >
    <p
      style={{
        margin: 0,
        fontSize: "14px",
        lineHeight: 1.5,
        fontWeight: 100,
        color: "rgb(77,67,56)",
      }}
    >
      {item.desc}
    </p>
  </div>
</div>
    ))}
  </div>

  <p
    style={{
      maxWidth: "850px",
      margin: "0 auto",
      fontSize: "14px",
      lineHeight: 1.6,
      color: "rgb(77,67,56,1)",
      fontWeight: 200,
      textAlign: isMobile ? "justify" : "center",
    }}
  >
    We make what we believe in — candles that transform not just how your home
    smells, but how it feels to be inside it.
  </p>
</section>

      {/* BOTTOM BANNER */}

{!isMobile && (
     <div
  style={{
    position: "relative",
    width: "100%",
  }}
>
  <img
    src="/banner/candle banner5.jpeg"
    alt="Flame"
    style={{
      width: "82%",
      objectFit: "contain",
      display: "block",
      margin:"0 auto"
    }}
  />
</div>
)}

{/* {isMobile && (
  <div
    style={{
      padding: "20px 20px",
      display: "flex",
      justifyContent: "center",
    }}
  >
    <div
      style={{
        borderRadius: "16px",
        padding: " 0 20px",
        
      }}
    >
      <h4
        style={{
          fontSize: isMobile ? "20px" : "25px",
          lineHeight: "1.3",
          marginBottom: "15px",
          fontWeight: "500",
           textAlign:"center",
            color:"#4c144e",
        }}
      >Aethearia - Others Follow, Crafted For The Soul.
         </h4>

      <img
        src="/images/serenelle.jpeg"
        alt="Wellness"
        style={{
          width: "100%",
          objectFit: "cover",
          borderRadius: "5px",
          marginBottom: "15px",
        }}
      />

      <p
        style={{
          fontSize: "15px",
          lineHeight: "1.7",
          color: "#444",
          textAlign:"center"
        }}
      >
   Flame
You Deserve A Home That Restores You A Routine That Holds You. A Space That, At The End Of The Hardest Day, Fels Like Enough.
     
      </p>
    </div>
  </div>
)} */}
      {/* FOOTER */}
     <Footer/>
    </div>
  );
}